import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import "./newstyle.css";
import { IDS } from "../../../../utils/IDS";
// import {
//   GetAll,
//   GetSingle,
//   Update,
//   Create,
// } from "../../../../features/admin/customer-management/driver/Slice";
import { useDispatch } from "react-redux";
import { set, useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import {
  GetAll,
  updateDriverStatus,
  uploadVehicleImages,
} from "../../../../features/admin/customer-management/driver/Slice";
import { formatDate } from "../../../../utils/common";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import View_img_Modal from "../../../common-components/common_Modal/view_img_Modal/View_img_Modal";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faUser } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
const Country = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  console.log(selectedDriver, "selectedDriverselectedDriver");

  const [image, setImage] = useState("");

  const dispatch = useDispatch();

  const {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    vehicleType,
    setVehicleType,
    fetch,
    deleteData,
    toggleStatus,
    driverStatus,
    setDriverStatus,
  } = IndexUse();

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const vehicleTypeParam = params.get("vehicleType");

    if (vehicleTypeParam) {
      setVehicleType(vehicleTypeParam);
    }
  }, [location.search]);

  useEffect(() => {
    if (vehicleType) {
      fetch(); // run when vehicleType is updated
    }
  }, [vehicleType]);

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [vehicleFront, setVehicleFront] = useState(null);
  const [vehicleBack, setVehicleBack] = useState(null);
  const [vehicleLeft, setVehicleLeft] = useState(null);
  const [vehicleRight, setVehicleRight] = useState(null);

  // Preview URLs
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);
  const [leftPreview, setLeftPreview] = useState(null);
  const [rightPreview, setRightPreview] = useState(null);
  // For Driver Documents
  const [documentFiles, setDocumentFiles] = useState({}); // { document_id: File }
  const [documentPreviews, setDocumentPreviews] = useState({}); // { document_id: previewUrl }

  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [showSuccessfull, setShowSuccessful] = useState(false);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  const handleStatusUpdate = async (driverId, statusId) => {
    const selectedDriverData = country?.data?.data?.find(
      (d) => d.id === driverId,
    );

    try {
      const res = await dispatch(
        updateDriverStatus({
          driver_id: driverId,
          status_id: Number(statusId),
        }),
      );

      if (res?.meta?.requestStatus == "fulfilled") {
        await dispatch(GetAll());
        setShowSuccessful(true);
        setSuccess(true);
        fetch();
        setTimeout(() => {
          setSuccess(false);
          setShowSuccessful(false);
        }, 3000);
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Status update failed:", error);
      setErr(true);
    }
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const HandleDownload = async () => {
    try {
      await DOWNLOAD_EXCEL(
        "/admin/driver/download",
        country?.data?.data,
        "Driver List",
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const vehicleTypeOptions = [
    { value: "Cab", label: "Cab" },
    { value: "Transport", label: "Transport" },
    { value: "Share", label: "Share" },
  ];

  const userStatusOptions = [
    { value: "1", label: "Requested" },
    { value: "2", label: "Accepted" },
    { value: "3", label: "Rejected" },
  ];

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  const handleVehicleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    switch (type) {
      case "front":
        setVehicleFront(file);
        setFrontPreview(previewUrl);
        break;
      case "back":
        setVehicleBack(file);
        setBackPreview(previewUrl);
        break;
      case "left":
        setVehicleLeft(file);
        setLeftPreview(previewUrl);
        break;
      case "right":
        setVehicleRight(file);
        setRightPreview(previewUrl);
        break;
      default:
        break;
    }
  };

  const handleVehicleImagesSubmit = async () => {
    if (!selectedDriver?.id) return;

    const formData = new FormData();

    // Vehicle Images
    if (vehicleFront) formData.append("vehicle_front", vehicleFront);
    if (vehicleBack) formData.append("vehicle_back", vehicleBack);
    if (vehicleLeft) formData.append("vehicle_left", vehicleLeft);
    if (vehicleRight) formData.append("vehicle_right", vehicleRight);

    // Driver Documents
    Object.keys(documentFiles).forEach((docId) => {
      formData.append("document_ids[]", docId);
      formData.append("documents[]", documentFiles[docId]);
    });

    // Check if anything is selected
    const hasVehicleImage =
      vehicleFront || vehicleBack || vehicleLeft || vehicleRight;
    const hasDocuments = Object.keys(documentFiles).length > 0;

    if (!hasVehicleImage && !hasDocuments) {
      alert("Please select at least one image to update");
      return;
    }

    try {
      const res = await dispatch(
        uploadVehicleImages({
          id: selectedDriver.id,
          data: formData,
        }),
      );

      if (res?.meta?.requestStatus === "fulfilled") {
        setShowSuccessful(true);
        setSuccess(true);

        // Refresh list
        await dispatch(GetAll());
        fetch();

        // Close modal after success
        setTimeout(() => {
          setShowSuccessful(false);
          setShowModal(false);
          setSelectedDriver(null);
        }, 2000);
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setErr(true);
    }
  };

  const handleDocumentChange = (e, documentId) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    setDocumentFiles((prev) => ({
      ...prev,
      [documentId]: file,
    }));

    setDocumentPreviews((prev) => ({
      ...prev,
      [documentId]: previewUrl,
    }));
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title={`${vehicleType} Drivers`} alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={f_name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by First Name</label>
              <Form.Control
                type="text"
                placeholder="Enter First Name"
                value={first_name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Email</label>
              <Form.Control
                type="text"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setemail(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Contact Number</label>
              <Form.Control
                type="text"
                placeholder="Enter Contact Number"
                value={contact_no}
                onChange={(e) => setcontact_no(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Type</label>

              <Select
                options={vehicleTypeOptions}
                value={
                  vehicleTypeOptions.find(
                    (option) => option.value === vehicleType,
                  ) || null
                }
                onChange={(selectedOption) =>
                  setVehicleType(selectedOption?.value || "")
                }
                placeholder="Select Type"
                isClearable
              />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by User Status</label>

              <Select
                options={userStatusOptions}
                value={
                  userStatusOptions.find(
                    (option) => option.value === driverStatus,
                  ) || null
                }
                onChange={(selectedOption) =>
                  setDriverStatus(selectedOption?.value || "")
                }
                placeholder="Select User Status"
                isClearable
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                  setemail("");
                  setcontact_no("");
                  setVehicleType("");
                  setDriverStatus("");
                }}
              >
                Reset
              </button>
            </div>
            <div className="mb-3">
              {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
              {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
              <button className="btn btn-success " onClick={HandleDownload}>
                Download Excel
              </button>
            </div>{" "}
          </div>
        </div>
      </div>
      {/* <Add id={id} setId={setId} /> */}
      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                {" "}
                {/* <th>
                  <input
                    type="checkbox"
                    value="selectAll"
                    checked={allChecked.length === selectAllChecked.length}
                    onChange={handleChange}
                    id="selectAll"
                    className="me-1"
                  ></input>
                  Select
                </th> */}
                <th>S. no.</th>
                <th>First Name</th>
                <th>Email</th>
                <th>Contact No</th>
                <th>Type</th>
                <th>Profile Photo</th>
                <th className="border-none-holder">Date</th>
                <th>Driver Status</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {country?.data?.data?.length > 0 ? (
                country?.data.data?.map((val, index) => (
                  <tr key={index}>
                    {/* <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={val?.id}
                        name="perselected"
                        checked={selectAllChecked.includes(val?.id)}
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                    </td>{" "} */}
                    <td>
                      {country?.data?.total -
                        ((country?.data?.current_page - 1) *
                          country?.data?.per_page +
                          index)}
                    </td>
                    <td>{val?.first_name}</td>
                    <td>{val?.email}</td>
                    <td>{val?.contact_no}</td>
                    <td>{val?.type}</td>
                    <td>
                      {val?.profile_photo && (
                        <img
                          src={`${IDS.IMG_URL}${val?.profile_photo}`}
                          alt="Image"
                          className="tableimg"
                          onClick={() => {
                            setModalShow(true);
                            setImage(val?.profile_photo);
                          }}
                        />
                      )}
                    </td>
                    <td>
                      {new Date(val?.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        // hour: "2-digit",
                        // minute: "2-digit",
                        // hour12: true,
                      })}
                    </td>
                    <td>
                      <Form.Select
                        value={val.driver_status_id}
                        onChange={(e) =>
                          handleStatusUpdate(val.id, Number(e.target.value))
                        }
                        disabled={Number(val.driver_status_id) !== 1} // Ensure type-safe comparison
                      >
                        {Number(val.driver_status_id) === 1 ? (
                          <>
                            <option value="">Select</option>
                            <option value={2}>Accepted</option>
                            <option value={3}>Rejected</option>
                          </>
                        ) : (
                          <option value={val.driver_status_id}>
                            {{
                              2: "Accepted",
                              3: "Rejected",
                            }[Number(val.driver_status_id)] || "Unknown"}
                          </option>
                        )}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Check
                        type="switch"
                        id={`custom-switch-${val?.id}`}
                        checked={val?.status}
                        onChange={() => {
                          if (
                            window.confirm(
                              `Are you sure you want to ${
                                val?.status ? "Deactivate" : "Activate"
                              } this Driver?`,
                            )
                          ) {
                            handleStatusChange(val?.id);
                          }
                        }}
                        label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                      />
                    </td>
                    <td>
                      <div className="action_btns">
                        <button
                          className="btn view-btn btn-sm"
                          // onClick={() => {
                          //   setSelectedDriver(val);
                          //   setImage(val?.profile_photo);
                          //   setShowModal(true);
                          // }}

                          onClick={() => {
                            setSelectedDriver(val);
                            setImage(val?.profile_photo);

                            // Reset vehicle images
                            setVehicleFront(null);
                            setVehicleBack(null);
                            setVehicleLeft(null);
                            setVehicleRight(null);
                            setFrontPreview(null);
                            setBackPreview(null);
                            setLeftPreview(null);
                            setRightPreview(null);

                            // Reset documents
                            setDocumentFiles({});
                            setDocumentPreviews({});

                            setShowModal(true);
                          }}
                        >
                          {/* View Details */}
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {selectedDriver && (
        <div
          className={`modal ${showModal ? "d-block" : "d-none"}`}
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-xl
          "
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Driver Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                    setImage("");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Vehicle Category</th>
                      <td>
                        {selectedDriver.Driver_Detail?.Vehicle_Category?.name ||
                          "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>Vehicle Name</th>
                      <td>
                        {selectedDriver?.Driver_Detail?.Vehicle?.name || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>Vehicle Body Type</th>
                      <td>
                        {selectedDriver?.Driver_Detail?.Vehicle_Body_Type
                          ?.name || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>Owner Number</th>
                      <td>
                        {selectedDriver?.Driver_Detail?.owner_number || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>Vehicle Number</th>
                      <td>
                        {selectedDriver.Driver_Detail?.vehicle_number || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>City</th>
                      <td>{selectedDriver.Driver_Detail?.City?.name || "-"}</td>
                    </tr>
                    <tr>
                      <th>Driver Video</th>
                      <td>{selectedDriver.training_video ? "Yes" : "No"}</td>
                    </tr>
                    <tr>
                      <th>Driver Type</th>
                      <td>{selectedDriver.type || "-"}</td>
                    </tr>
                  </tbody>
                </table>

                <hr />
                <h5>Driver Documents</h5>
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        {/* ===================== Vehicle Front ===================== */}
                        <div className="col-md-6">
                          <div className="mb-4">
                            <strong className="d-block mb-2">
                              Vehicle Front Image
                            </strong>
                            <div className="imge-imput">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleVehicleImageChange(e, "front")
                                }
                              />
                            </div>

                            {frontPreview ? (
                              <img
                                src={frontPreview}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            ) : selectedDriver.Driver_Detail?.vehicle_front ? (
                              <img
                                src={`${IDS.IMG_URL}${selectedDriver.Driver_Detail?.vehicle_front}`}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() => {
                                  setImage(
                                    selectedDriver.Driver_Detail?.vehicle_front,
                                  );
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f1f1f1",
                                  borderRadius: "10px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faUser}
                                  style={{ fontSize: "120px", color: "#999" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ===================== Vehicle Back ===================== */}
                        <div className="col-md-6">
                          <div className="mb-4">
                            <strong className="d-block mb-2">
                              Vehicle Back Image
                            </strong>
                            <div className="imge-imput">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleVehicleImageChange(e, "back")
                                }
                              />
                            </div>

                            {backPreview ? (
                              <img
                                src={backPreview}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            ) : selectedDriver.Driver_Detail?.vehicle_back ? (
                              <img
                                src={`${IDS.IMG_URL}${selectedDriver.Driver_Detail?.vehicle_back}`}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() => {
                                  setImage(
                                    selectedDriver.Driver_Detail?.vehicle_back,
                                  );
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f1f1f1",
                                  borderRadius: "10px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faUser}
                                  style={{ fontSize: "120px", color: "#999" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ===================== Vehicle Left ===================== */}
                        <div className="col-md-6">
                          <div className="mb-4">
                            <strong className="d-block mb-2">
                              Vehicle Left Image
                            </strong>
                            <div className="imge-imput">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleVehicleImageChange(e, "left")
                                }
                              />
                            </div>

                            {leftPreview ? (
                              <img
                                src={leftPreview}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            ) : selectedDriver.Driver_Detail?.vehicle_left ? (
                              <img
                                src={`${IDS.IMG_URL}${selectedDriver.Driver_Detail?.vehicle_left}`}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() => {
                                  setImage(
                                    selectedDriver.Driver_Detail?.vehicle_left,
                                  );
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f1f1f1",
                                  borderRadius: "10px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faUser}
                                  style={{ fontSize: "120px", color: "#999" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ===================== Vehicle Right ===================== */}
                        <div className="col-md-6">
                          <div className="mb-4">
                            <strong className="d-block mb-2">
                              Vehicle Right Image
                            </strong>
                            <div className="imge-imput">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleVehicleImageChange(e, "right")
                                }
                              />
                            </div>

                            {rightPreview ? (
                              <img
                                src={rightPreview}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            ) : selectedDriver.Driver_Detail?.vehicle_right ? (
                              <img
                                src={`${IDS.IMG_URL}${selectedDriver.Driver_Detail?.vehicle_right}`}
                                className="img-fluid rounded border"
                                style={{
                                  maxHeight: "200px",
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() => {
                                  setImage(
                                    selectedDriver.Driver_Detail?.vehicle_right,
                                  );
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f1f1f1",
                                  borderRadius: "10px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faUser}
                                  style={{ fontSize: "120px", color: "#999" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {selectedDriver.Driver_Documents?.map((doc) => (
                          <div className="col-md-6" key={doc.id}>
                            <div className="mb-4">
                              <strong className="d-block mb-2">
                                {doc?.Document?.name}
                              </strong>

                              <div className="imge-imput">
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleDocumentChange(e, doc.document_id)
                                  }
                                />
                              </div>

                              {/* Show new preview if selected, otherwise show existing image */}
                              {documentPreviews[doc.document_id] ? (
                                <img
                                  src={documentPreviews[doc.document_id]}
                                  className="img-fluid rounded border"
                                  style={{
                                    maxHeight: "200px",
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : doc.document ? (
                                <img
                                  src={`${IDS.IMG_URL}${doc.document}`}
                                  alt={doc?.Document?.name}
                                  className="img-fluid rounded border"
                                  style={{
                                    maxHeight: "200px",
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                  onClick={() => {
                                    setImage(doc.document);
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "200px",
                                    height: "200px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#f1f1f1",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    style={{
                                      fontSize: "120px",
                                      color: "#999",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="btn-wrapper">
                        <Button
                          className="btn btn-success"
                          style={{ width: "fit-content" }}
                          onClick={handleVehicleImagesSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {image ? (
                        <img
                          src={`${IDS.IMG_URL}${image}`}
                          className="img-fluid rounded border"
                          style={{
                            maxHeight: "700px",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "400px",
                            height: "400px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f1f1f1",
                            borderRadius: "10px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faUser}
                            style={{
                              fontSize: "120px",
                              color: "#999",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Pagination_Holder
        onPageChange={country?.data?.current_page}
        totalPages={country?.data?.total_pages}
        handlePageChange={handlePageChange}
      />{" "}
      <Successfull_Modal
        message={"Status Successful"}
        show={showSuccessfull}
        onHide={() => setShowSuccessful(false)}
      />
      <View_img_Modal
        show={modalShow}
        image={image}
        setImage={setImage}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Country;
